import React, { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { AppPageBody } from '@app'
import { pageActions, pageSubtitle, pageTitle } from '@app/@signals'

import { SESSIONS_ROUTES } from '@constants'
import { useUserApp } from '@hooks'
import PageWrapperActions from './Actions'
import { AppOfficesModal, AppSitesModal } from '@components'


export default function PageWrapper({ children, title, subtitle, actions, showReportsSelect = false, directsite = null, showAnalyzersLinks = false, ...props }) {
	const { pathname, search, hash } = useLocation()
	const { isLogged } = useUserApp()

	const headerActions = !actions ? <PageWrapperActions
		showReportsSelect={showReportsSelect}
		showAnalyzersLinks={showAnalyzersLinks}
		directsite={directsite}/> : actions

	// The shell header is the single place for the page title and its actions;
	// the body below draws the rest (tab title, banner, filters, modals)
	useEffect(() => {
		pageTitle.value = title || ''
		pageSubtitle.value = subtitle || ''
		pageActions.value = headerActions
	})

	useEffect(() => () => {
		pageTitle.value = ''
		pageSubtitle.value = ''
		pageActions.value = null
	}, [])

	if (!isLogged)
		return <Navigate to={`${SESSIONS_ROUTES.LOGIN_URL}?redirect=${encodeURIComponent(pathname + search + hash)}`} replace/>

	// the testing environment is announced by a badge in the shell header, not a banner over the page
	return <AppPageBody {...props}>
		<AppOfficesModal/>
		<AppSitesModal/>
		{children}
	</AppPageBody>
}
